import { Button, Skeleton, Tabs } from "antd";
import { complexDigitToman } from "../../../tools/tools";
import { DotChartOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const Wallets = ({ _currentUser }) => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    setTimeout(async () => {
      setIsLoading(false);
    }, 1000);
  }, []);
  return (
    <>
      <div className="holder-box-right">
        {isLoading ? (
          <Skeleton.Node fullSize="true" style={{ width: "100%", height: "335px" }} active="true">
            <DotChartOutlined style={{ fontSize: 40, color: "#bfbfbf" }} />
          </Skeleton.Node>
        ) : (
          <div className="holder-box wallet">
            <div className="overly"></div>
            <div className="box-text">
              <div className="head-title">
                <div className="hold-text">
                  <h3>اعتبار</h3>
                </div>
                {_currentUser?.ccwalletamount !== 0 && _currentUser?.cpwalletamount !== 0 ? (
                  <Tabs
                    className="tab-holder"
                    defaultActiveKey="1"
                    centered
                    items={[
                      {
                        key: "1",
                        label: "کیف پول بسته",
                        children: (
                          <>
                            <div className="body-text">
                              <span>اعتبار کیف پول بسته</span>
                              <h3>
                                <span>{complexDigitToman(_currentUser?.cpwalletamount)}</span> تومان
                              </h3>
                            </div>
                            <div className="footer-button">
                              <Button className="btn" type="text">
                                شارژ کیف پول بسته
                              </Button>
                              <Button className="btn" type="text">
                                تاریخچه اعتبار
                              </Button>
                            </div>
                          </>
                        ),
                      },
                      {
                        key: "2",
                        label: "کیف پول شارژ",
                        children: (
                          <>
                            <div className="body-text">
                              <span>اعتبار کیف پول شارژ</span>
                              <h3>
                                <span>{complexDigitToman(_currentUser?.ccwalletamount)}</span> تومان
                              </h3>
                            </div>
                            <div className="footer-button">
                              <Button className="btn" type="text">
                                شارژ کیف پول شارژ
                              </Button>
                              <Button className="btn" type="text">
                                تاریخچه اعتبار
                              </Button>
                            </div>
                          </>
                        ),
                      },
                    ]}
                  />
                ) : (
                  <>
                    <div className="hold-icon">
                      <div className="under-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="89" height="89" viewBox="0 0 89 89" fill="none">
                          <g filter="url(#filter0_d_6266_6412)">
                            <circle cx="44.5" cy="44.5" r="41.5" fill="#F9F9F9" />
                          </g>
                          <path
                            d="M25.3622 36.3646H23.4298C21.7873 36.3646 20.5312 35.1107 20.5312 33.4932V62.2072C20.5312 63.8247 21.7873 65.0786 23.4298 65.0786H25.3622V36.3646Z"
                            fill="#E9EAEB"
                          />
                          <path
                            d="M20.5312 33.4866C20.5312 35.1042 21.7873 36.358 23.4298 36.358H60.1447V30.6152H23.4298C21.7873 30.6152 20.5312 31.8691 20.5312 33.4866Z"
                            fill="#E9EAEB"
                          />
                          <path
                            d="M60.1447 36.358V30.6152H23.4298C21.7873 30.6152 20.5312 31.8691 20.5312 33.4866"
                            stroke="#4D4D4D"
                            strokeWidth="1.98691"
                            strokeMiterlimit="10"
                          />
                          <path d="M55.3985 36.3561L41.7946 22.8701L28.1328 36.3561" fill="#E64225" />
                          <path d="M55.3985 36.3561L41.7946 22.8701L28.1328 36.3561" stroke="#4D4D4D" strokeWidth="1.98691" strokeMiterlimit="10" />
                          <path d="M48.55 36.354L43.8447 31.6641C42.4824 33.0136 41.1104 33.0232 39.7481 31.6641L35.0234 36.354" fill="#E9EAEB" />
                          <path
                            d="M48.55 36.354L43.8447 31.6641C42.4824 33.0136 41.1104 33.0232 39.7481 31.6641L35.0234 36.354"
                            stroke="#4D4D4D"
                            strokeWidth="1.98691"
                            strokeMiterlimit="10"
                          />
                          <path
                            d="M64.9756 65.0786H23.4298C21.7873 65.0786 20.5312 63.8247 20.5312 62.2072V33.4932C20.5312 35.1107 21.7873 36.3646 23.4298 36.3646H64.9756V65.0786Z"
                            stroke="#4D4D4D"
                            strokeWidth="1.98691"
                            strokeMiterlimit="10"
                          />
                          <path
                            d="M65.9408 55.5041H51.9312C48.994 55.5041 46.6172 53.1495 46.6172 50.2398C46.6172 47.3301 48.994 44.9756 51.9312 44.9756H65.9408C67.0036 44.9756 67.8732 45.837 67.8732 46.8899V53.5898C67.8732 54.6426 67.0036 55.5041 65.9408 55.5041Z"
                            fill="#E64225"
                            stroke="#4D4D4D"
                            strokeWidth="1.98691"
                            strokeMiterlimit="10"
                          />
                          <path
                            d="M50.4844 50.2317C50.4844 48.9109 51.5665 47.8389 52.8998 47.8389C54.2332 47.8389 55.3153 48.9109 55.3153 50.2317C55.3153 51.5525 54.2332 52.6245 52.8998 52.6245C51.5665 52.6245 50.4844 51.5525 50.4844 50.2317Z"
                            fill="white"
                            stroke="#4D4D4D"
                            strokeWidth="1.98691"
                            strokeMiterlimit="10"
                          />
                          <defs>
                            <filter
                              id="filter0_d_6266_6412"
                              x="0.287888"
                              y="0.287888"
                              width="88.4242"
                              height="88.4242"
                              filterUnits="userSpaceOnUse"
                              colorInterpolationFilters="sRGB"
                            >
                              <feFlood floodOpacity="0" result="BackgroundImageFix" />
                              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                              <feOffset />
                              <feGaussianBlur stdDeviation="1.35606" />
                              <feComposite in2="hardAlpha" operator="out" />
                              <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
                              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_6266_6412" />
                              <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_6266_6412" result="shape" />
                            </filter>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div className="body-text">
                      <span>اعتبار کیف پول بسته</span>
                      <h3>
                        <span>{complexDigitToman(_currentUser?.walletAmount)}</span> تومان
                      </h3>
                    </div>
                    <div className="footer-button">
                      <Button className="btn" type="text">
                        شارژ کیف پول بسته
                      </Button>
                      <Button className="btn" type="text">
                        تاریخچه اعتبار
                      </Button>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Wallets;
